// src/hooks/usePreventZoom.ts
import { onCleanup, onMount } from "solid-js";

import { isMobile } from "@/lib/isMobile";

export function usePreventZoom() {
  onMount(() => {
    const handelTounchStart = (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    const handleTouchEnd = (event: TouchEvent) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    };

    const handleDoubleClick = (event: MouseEvent) => {
      event.preventDefault();
    };

    const handleContextMenu = (event: MouseEvent) => {
      // 只在移动设备上禁用右键菜单
      if (isMobile()) {
        event.preventDefault();
      }
    };

    const handleGesture = (event: Event) => {
      event.preventDefault();
    };

    let lastTouchEnd = 0;

    document.addEventListener("touchstart", handelTounchStart, false);
    // document.addEventListener("touchend", handleTouchEnd, false);
    document.addEventListener("dblclick", handleDoubleClick);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("gesturestart", handleGesture);
    document.addEventListener("gesturechange", handleGesture);
    document.addEventListener("gestureend", handleGesture);

    // 可选：CSS 动态设置
    document.documentElement.style.touchAction = "manipulation";

    onCleanup(() => {
      document.removeEventListener("touchstart", handelTounchStart);
      // document.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("dblclick", handleDoubleClick);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("gesturestart", handleGesture);
      document.removeEventListener("gesturechange", handleGesture);
      document.removeEventListener("gestureend", handleGesture);
      document.documentElement.style.touchAction = "";
    });
  });
}
